/* 夏侯淵傳・第 5 章：枹罕（214 年）
 * 枹罕是四門的方城；西邊是黃河（河關、小湟中在河的對岸），夏侯淵從東邊來。 */
export const CITY = { x: 4200, y: 2600, hw: 1000, hh: 700 };
const T = 36, G = 130, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const GATES = { e: [E, CITY.y], n: [CITY.x, N], s: [CITY.x, S], w: [Wx, CITY.y] };
// 圍營立在城門外
export const SIEGE = { e: [E + 380, CITY.y], n: [CITY.x, N - 330], s: [CITY.x, S + 330], w: [Wx - 380, CITY.y] };
export const START = [7300, 2600];
const h = (y: number) => [[(Wx + CITY.x - G) / 2, y, (CITY.x - G - Wx) / 2 + T, T], [(CITY.x + G + E) / 2, y, (E - CITY.x - G) / 2 + T, T]];
const v = (x: number) => [[x, (N + CITY.y - G) / 2, T, (CITY.y - G - N) / 2], [x, (CITY.y + G + S) / 2, T, (S - CITY.y - G) / 2]];
export default {
  id: 'xiahouyuan_fuhan', name: '枹罕', W: 8000, H: 5400, seed: 2142,
  bases: [START, [CITY.x, CITY.y]],
  walls: [...h(N), ...h(S), ...v(Wx), ...v(E)],
  rivers: [{ pts: [[700, -100], [900, 1800], [600, 3600], [800, 5500]], hw: 220, fords: [] }],
  roads: [
    { pts: [START, SIEGE.e, GATES.e, [CITY.x, CITY.y], GATES.w, SIEGE.w], w: 120 },
    { pts: [[CITY.x, 500], SIEGE.n, GATES.n, [CITY.x, CITY.y], GATES.s, SIEGE.s, [CITY.x, 4900]], w: 110 },
    { pts: [SIEGE.e, [5800, 1500], [CITY.x + 600, 1500], SIEGE.n, [CITY.x - 600, 1500], [2500, 1700], SIEGE.w, [2500, 3500], [CITY.x - 600, 3700], SIEGE.s, [CITY.x + 600, 3700], [5800, 3500], SIEGE.e], w: 100 }, // 繞城一圈
  ],
  rocks: [[6800, 900, 380, 180], [6800, 4400, 380, 180], [1900, 800, 300, 150], [1900, 4500, 300, 150]],
  woods: 0.35,
  sight: 0.85,
  clearings: [[CITY.x, CITY.y, 1200], [START[0], START[1], 450], ...Object.values(SIEGE).map(([x, y]) => [x, y, 280])],
  villages: [{ x: CITY.x - 450, y: CITY.y - 300, n: 5, r: 260 }, { x: CITY.x + 450, y: CITY.y + 300, n: 5, r: 260 }],
  tents: [{ x: START[0], y: START[1], n: 5, r: 360, chief: true, col: '#3b5a99', flag: '夏' }],
};
